import React from "react";
import { useTranslation } from "react-i18next";
import AdminMobileTopbar from "./AdminMobileTopbar";
import ClientChart from "../adminComponents/ClientChart";
import QualityDemographic from "../adminComponents/QualityDemographic";
import { useClientPanel } from "./useClientPanel";

/**
 * Mobile version of admin/ClientDashboard.jsx - same data (via
 * useClientPanel), same ClientChart/QualityDemographic components
 * already used on desktop (both already responsive). The wide
 * horizontally-scrollable month table is replaced with one card per
 * month, which fits the mobile-card pattern used across this project.
 */
const MobileClientDashboard = () => {
  const { t } = useTranslation();
  const clientName = sessionStorage.getItem("clientName") || "";
  const { dashboardData, loading, error, monthCards } = useClientPanel();

  return (
    <div className="flex flex-col h-screen bg-secondaryBg">
      <AdminMobileTopbar title={clientName || t("dashboard.dashboard")} />

      <div className="flex-1 overflow-y-auto px-4 py-4 flex flex-col gap-3">
        {loading && <p className="text-xs text-gray-400 text-center py-8">{t("dashboard.loading")}</p>}
        {error && <p className="text-xs text-red-500 text-center py-8">{t("error.generic")}</p>}

        {!loading && !error && (
          <>
            <div className="bg-white rounded-xl border border-gray-200 p-3.5">
              <p className="text-[11px] text-gray-500 mb-2">{t("dashboard.clientDashboard.industryChart", "Industrias")}</p>
              <ClientChart dashboardData={dashboardData} />
            </div>

            <div className="bg-white rounded-xl border border-gray-200 p-3.5">
              <QualityDemographic dashboardData={dashboardData} />
            </div>

            <p className="text-[11px] text-gray-500 mt-1">{t("dashboard.clientDashboard.monthlyBreakdown", "Detalle mensual")}</p>

            {monthCards.map((m, idx) => (
              <div key={idx} className="bg-white rounded-xl border border-gray-200 p-3.5">
                <p className="text-[13px] font-bold text-primary mb-2 capitalize">{m.label}</p>
                <div className="grid grid-cols-3 gap-2">
                  <div className="bg-secondaryBg rounded-lg p-2 text-center">
                    <p className="text-sm font-bold text-primary m-0">{m.contacts}</p>
                    <p className="text-[9px] text-gray-500 m-0">{t("dashboard.clientDashboard.Contacts")}</p>
                  </div>
                  <div className="bg-secondaryBg rounded-lg p-2 text-center">
                    <p className="text-sm font-bold text-primary m-0">{m.calls}</p>
                    <p className="text-[9px] text-gray-500 m-0">{t("dashboard.clientDashboard.Calls")}</p>
                  </div>
                  <div className="bg-secondaryBg rounded-lg p-2 text-center">
                    <p className="text-sm font-bold text-primary m-0">{m.answered}</p>
                    <p className="text-[9px] text-gray-500 m-0">{t("agent.noteInfo.answered")}</p>
                  </div>
                  <div className="bg-secondaryBg rounded-lg p-2 text-center">
                    <p className="text-sm font-bold text-primary m-0">{m.interested}</p>
                    <p className="text-[9px] text-gray-500 m-0">{t("agent.noteInfo.interested")}</p>
                  </div>
                  <div className="bg-secondary/10 rounded-lg p-2 text-center">
                    <p className="text-sm font-bold text-secondary m-0">{m.scheduled}</p>
                    <p className="text-[9px] text-gray-500 m-0">{t("agent.noteInfo.scheduled")}</p>
                  </div>
                  <div className="bg-secondaryBg rounded-lg p-2 text-center">
                    <p className="text-sm font-bold text-primary m-0">{m.effective}</p>
                    <p className="text-[9px] text-gray-500 m-0">{t("dashboard.clientDashboard.effectiveScheduled")}</p>
                  </div>
                </div>
              </div>
            ))}
          </>
        )}
      </div>
    </div>
  );
};

export default MobileClientDashboard;
